import { createTheme, alpha } from '@mui/material/styles';
import { colorTokens, radiusTokens, shadowTokens } from './tokens';

export const appTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: colorTokens.primary,
      dark: colorTokens.primaryStrong,
      contrastText: colorTokens.ink,
    },
    secondary: {
      main: colorTokens.secondary,
      light: colorTokens.secondarySoft,
      contrastText: colorTokens.ink,
    },
    success: {
      main: colorTokens.success,
    },
    warning: {
      main: colorTokens.warning,
    },
    error: {
      main: colorTokens.danger,
    },
    info: {
      main: colorTokens.info,
    },
    background: {
      default: colorTokens.canvas,
      paper: colorTokens.surface,
    },
    text: {
      primary: colorTokens.ink,
      secondary: colorTokens.inkMuted,
    },
    divider: colorTokens.line,
  },
  shape: {
    borderRadius: radiusTokens.card,
  },
  typography: {
    fontFamily: '"Segoe UI", "Helvetica Neue", Arial, sans-serif',
    h1: {
      fontSize: '3rem',
      lineHeight: 1.05,
      fontWeight: 800,
    },
    h2: {
      fontSize: '2.25rem',
      lineHeight: 1.1,
      fontWeight: 800,
    },
    h3: {
      fontSize: '1.75rem',
      lineHeight: 1.2,
      fontWeight: 700,
    },
    h4: {
      fontSize: '1.5rem',
      lineHeight: 1.2,
      fontWeight: 700,
    },
    h5: {
      fontSize: '1.125rem',
      lineHeight: 1.3,
      fontWeight: 700,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.7,
    },
    body2: {
      fontSize: '0.92rem',
      lineHeight: 1.6,
    },
    button: {
      fontWeight: 700,
      textTransform: 'none',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          paddingInline: 22,
          paddingBlock: 10,
          minHeight: 44,
          whiteSpace: 'nowrap',
          fontSize: '0.95rem',
          lineHeight: 1.2,
          boxShadow: 'none',
          fontWeight: 600,
        },
        containedPrimary: {
          boxShadow: '0 2px 8px rgba(27, 111, 207, 0.24)',
          backgroundColor: '#1b6fcf',
          color: '#ffffff',
          border: '1px solid #1564bd',
          '&:hover': {
            backgroundColor: '#1564bd',
            boxShadow: '0 3px 10px rgba(27, 111, 207, 0.28)',
          },
        },
        textSecondary: {
          color: '#1b6fcf',
          paddingInline: 8,
          minWidth: 'auto',
          '&:hover': {
            backgroundColor: colorTokens.secondarySoft,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: radiusTokens.card,
          border: `1px solid ${colorTokens.line}`,
          boxShadow: shadowTokens.soft,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: radiusTokens.pill,
          fontWeight: 700,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: `1px solid ${colorTokens.line}`,
          background: colorTokens.surfaceMuted,
          color: colorTokens.ink,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: radiusTokens.card,
        },
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 18,
          '&.Mui-selected': {
            backgroundColor: alpha(colorTokens.primary, 0.32),
          },
          '&:hover': {
            backgroundColor: alpha(colorTokens.primary, 0.18),
          },
        },
      },
    },
  },
});
